import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5675322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "table-scroll-container" }
const _hoisted_3 = {
  class: "table-auto border-separate w-auto",
  style: { 'border-spacing': 0 }
}
const _hoisted_4 = { class: "bg-blue-dark text-white sticky top-0 z-100" }
const _hoisted_5 = {
  class: "flex flex-col items-center justify-end h-full",
  style: {"padding-bottom":"0.2rem"}
}
const _hoisted_6 = {
  class: "font-bold select-none block rotate-header-text",
  style: {"white-space":"nowrap","display":"inline-block"}
}
const _hoisted_7 = { class: "inline-block h-5 w-5 text-center mt-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "flex flex-col items-center justify-end h-full",
  style: {"padding-bottom":"0.2rem"}
}
const _hoisted_11 = {
  class: "font-bold select-none block rotate-header-text",
  style: {"white-space":"nowrap","display":"inline-block"}
}
const _hoisted_12 = { class: "inline-block h-5 w-5 text-center mt-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex gap-1" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = {
  key: 1,
  class: "text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExplorerFilterInput = _resolveComponent("ExplorerFilterInput")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortBy('sura'))),
              class: "border-r border-white cursor-pointer px-0 py-0",
              style: _normalizeStyle({
                verticalAlign: 'bottom',
                paddingBottom: '0.1rem',
                height: '5rem',
                width: _ctx.combinedSuraVerseWidth,
                whiteSpace: 'nowrap',
              })
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('global.sura')) + ":" + _toDisplayString(_ctx.t('global.verse')), 1),
                _createElementVNode("span", _hoisted_7, [
                  (_ctx.sortKey === 'sura')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.sortAsc ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statColumns, (column, idx) => {
              return (_openBlock(), _createElementBlock("th", {
                key: column.key,
                onClick: ($event: any) => (_ctx.sortBy(column.key)),
                class: _normalizeClass([
                'cursor-pointer px-0 py-0',
                idx === _ctx.statColumns.length - 1 ? '' : 'border-r border-white',
              ]),
                style: _normalizeStyle({
                verticalAlign: 'bottom',
                paddingBottom: '0.1rem',
                height: '5rem',
                width: _ctx.columnWidth,
                whiteSpace: 'nowrap',
              })
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t(column.labelKey)), 1),
                  _createElementVNode("span", _hoisted_12, [
                    (_ctx.sortKey === column.key)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.sortAsc ? '▲' : '▼'), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 14, _hoisted_9))
            }), 128))
          ]),
          (_ctx.showFilters)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("th", {
                  class: "border-r border-gray-300 px-1 py-2",
                  style: _normalizeStyle({ width: _ctx.combinedSuraVerseWidth })
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ExplorerFilterInput, {
                        "column-key": "sura",
                        "filter-values": _ctx.filterValues,
                        min: _ctx.getSuraColumn()?.min || 1,
                        max: 114,
                        onUpdateFilter: _ctx.updateFilter
                      }, null, 8, ["filter-values", "min", "onUpdateFilter"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_ExplorerFilterInput, {
                        "column-key": "verse",
                        "filter-values": _ctx.filterValues,
                        min: _ctx.getVerseColumn()?.min || 1,
                        max: 286,
                        onUpdateFilter: _ctx.updateFilter
                      }, null, 8, ["filter-values", "min", "onUpdateFilter"])
                    ])
                  ])
                ], 4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statColumns, (column, idx) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: `filter-${column.key}`,
                    class: _normalizeClass([
                'px-1 py-2',
                idx === _ctx.statColumns.length - 1 ? '' : 'border-r border-gray-300',
              ]),
                    style: _normalizeStyle({ width: _ctx.columnWidth })
                  }, [
                    _createVNode(_component_ExplorerFilterInput, {
                      "column-key": column.key,
                      "filter-values": _ctx.filterValues,
                      min: _ctx.getStatColumn(column.key)?.min || 0,
                      max: _ctx.getStatColumn(column.key)?.max || 1000,
                      onUpdateFilter: _ctx.updateFilter
                    }, null, 8, ["column-key", "filter-values", "min", "max", "onUpdateFilter"])
                  ], 6))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, rowIdx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${row.sura}:${row.verse}`,
              class: _normalizeClass(rowIdx % 2 === 0 ? 'bg-white' : 'bg-grey-light')
            }, [
              _createElementVNode("td", {
                class: "whitespace-nowrap text-center align-middle bg-clip-padding px-1 py-0 h-auto",
                style: _normalizeStyle({
                width: _ctx.combinedSuraVerseWidth,
                background: 'transparent',
                borderRight: '1px solid #000',
              })
              }, [
                _createVNode(_component_router_link, {
                  to: { name: 'VersePrint', params: { sura: row.sura, verse: row.verse } },
                  class: "text-blue-600 hover:text-blue-800 hover:underline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(String(row.sura).padStart(3, '0')) + ":" + _toDisplayString(String(row.verse).padStart(3, '0')), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ], 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statColumns, (column, idx) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: column.key,
                  class: "align-top bg-clip-padding text-center",
                  style: _normalizeStyle({
                width: _ctx.columnWidth,
                background: 'transparent',
                borderRight: idx < _ctx.statColumns.length - 1 ? '1px solid #000' : 'none',
              })
                }, [
                  (_ctx.getColumnValue(row, column.key) > 0 && column.linkGenerator)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: column.linkGenerator(row),
                        class: "text-blue-600 hover:text-blue-800 hover:underline"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getColumnValue(row, column.key)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.getColumnValue(row, column.key)), 1))
                ], 4))
              }), 128))
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}